<div class="eiq-media-attachments" [attr.data-testid]="testId() ? testId() + '-media-attachments' : null">
  <div class="eiq-media-attachments__row">
    @for (item of media(); track item.mediaId; let i = $index) {
      <div class="eiq-media-attachments__thumb">
        @if (!readonly()) {
          <eiq-icon-button
            [icon]="faClose"
            [size]="'tiny'"
            [style]="'basic'"
            [color]="undefined"
            [tooltip]="'Remove'"
            [testId]="testId() ? testId() + '-media-attachments-remove-' + i : null"
            class="eiq-media-attachments__thumb-remove"
            (clicked)="remove.emit(i)"
          ></eiq-icon-button>
        }

        @if (item.type === fileType.VideoMp4) {
          <video [src]="item.url || (item.url$ | async)" controls></video>
        } @else if (item.type === fileType.AudioMp3) {
          <audio [src]="item.url || (item.url$ | async)" controls></audio>
        } @else {
          <img [src]="item.url || (item.url$ | async)" [alt]="item.name" />
        }
      </div>
    }

    @if (!readonly()) {
      <button
        type="button"
        class="eiq-media-attachments__add"
        [attr.data-testid]="testId() ? testId() + '-media-attachments-add-tile' : null"
        (click)="onAdd()"
      >
        <fa-icon [icon]="faPlus"></fa-icon>
        <span class="text__xs fw__600">Add</span>
      </button>
    }
  </div>
</div>
